"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFlexPlus = exports.isFCR = exports.isFCRNeg = exports.isFCRPos = exports.isAFrrMinus = exports.isAFrrPlus = exports.isMFrrMinus = exports.isMFrrPlus = exports.isDirectMarketing = void 0;
function isDirectMarketing(product) {
    return product?.id === '1' || product?.name === 'DV';
}
exports.isDirectMarketing = isDirectMarketing;
function isMFrrPlus(product) {
    return product?.id === '7';
}
exports.isMFrrPlus = isMFrrPlus;
function isMFrrMinus(product) {
    return product?.id === '8';
}
exports.isMFrrMinus = isMFrrMinus;
function isAFrrPlus(product) {
    return product?.id === '9';
}
exports.isAFrrPlus = isAFrrPlus;
function isAFrrMinus(product) {
    return product?.id === '10';
}
exports.isAFrrMinus = isAFrrMinus;
function isFCRPos(product) {
    return product?.id === '12';
}
exports.isFCRPos = isFCRPos;
function isFCRNeg(product) {
    return product?.id === '13';
}
exports.isFCRNeg = isFCRNeg;
function isFCR(product) {
    return product?.id === '12' || product?.id === '13';
}
exports.isFCR = isFCR;
function isFlexPlus(product) {
    return product?.id === '18';
}
exports.isFlexPlus = isFlexPlus;
